import React, { Component } from "react";
import PageHelmet from "../../component/common/Helmet";
import ModalVideo from 'react-modal-video';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../../component/header/Header";
import FooterTwo from "../../component/footer/FooterTwo";


class RePresence extends Component{
    constructor () {
        super()
        this.state = {
          isOpen: false
        }
        this.openModal = this.openModal.bind(this)
    }
    openModal () {
        this.setState({isOpen: true})
    }
    render(){
        return(
            <React.Fragment>
                
                {/* Start Pagehelmet  */}
                <PageHelmet pageTitle='Service Details' />
                {/* End Pagehelmet  */}

                <Header headertransparent="header--transparent" colorblack="color--white" logoname="logo.png" />

                {/* Start Breadcrump Area */}
                <div className="rn-page-title-area pt--120 pb--190" style={{ backgroundImage: `url("/assets/images/banner-bg.jpg")` }}  >
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-color ">RePresence</h2>
                                    <p>Mobile App</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}

                {/* Start Page Wrapper */}
                <div className="rn-service-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="service-details-inner">
                                    <div className="inner">
                                        {/* Start Single Area */}
                                        <div className="row sercice-details-content pb--80 align-items-top">
                                            <div className="col-lg-6 col-12">
                                                <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/work-51.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <p>RePresence is a prototype app I developed for mobile devices such Android and IOS. For pratical purpose, I wrote the code with Flutter since it can be exported in multi platform. The architecture used for this project is MVC. At first, I decided use Golang, MongoDB, Flutter and React.Js as a "Tech Stack". Then I started to implement them from the backend using Golang and Mongodb for a webservices/API. After that, I designed the frontend using Flutter for mobile and React.js for web.</p>
                                                    <p>The purpose of this app is to make employees and HR having easier access for doing attendance management and proccess.</p>
                                                    <h4 className="title">My Working Process</h4>
                                                    <ul className="liststyle">
                                                        <li>Designing class and activity diagram</li>
                                                        <li>Providing webservices written in Golang and MongoDB as a database</li>
                                                        <li>UI/UX Designing for mobile and web frontend</li>
                                                        <li>Implementing mobile frontend integration with backend using Flutter (employee side)</li>
                                                        <li>Implementing web frontend integration with backend using React.js (admin access)</li>
                                                        <li>Unit testing</li>
                                                        <li>Fixing visual and functional bugs</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}
                                        <h2 className="text-center mb--50">Project Screenshots</h2>
                                        {/* Start Single Area */}
                                        <div className="row sercice-details-content align-items-center">
                                        <div className="col-lg-4 col-12 order-1 order-lg-2">
                                        <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/work-43.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-12 order-1 order-lg-2">
                                            <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/work-44.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-12 order-1 order-lg-2">
                                            <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/work-45.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row sercice-details-content align-items-center mt--30">
                                        <div className="col-lg-4 col-12 order-1 order-lg-2">
                                        <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/work-46.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-12 order-1 order-lg-2">
                                            <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/work-47.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-12 order-1 order-lg-2">
                                            <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/work-48.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row sercice-details-content align-items-center mt--30">
                                        <div className="col-lg-4 col-12 order-1 order-lg-2">
                                        <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/work-49.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-12 order-1 order-lg-2">
                                            <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/work-50.png" alt="Service Images"/>
                                                </div>
                                            </div>
                        
                                        </div>
                                        {/* End Single Area */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Page Wrapper */}
                
                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <FooterTwo />
            </React.Fragment>
        )
    }
}
export default RePresence;